import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValidationMessageResolver } from '@ngx-strakit/validation';

@Injectable()
export class SkMaxLengthValidationMessageResolver implements ValidationMessageResolver<{ requiredLength: unknown }> {
  private readonly translate = inject(TranslateService);
  readonly errorCode = 'maxlength';

  getMessage(error?: { requiredLength: unknown }): string {
    return this.translate.instant('label.validation.maxLength.value', { value: error?.requiredLength });
  }
}
